import moment          from 'moment/moment';

import { dateFormats } from './dateFormats';


enum LogLevel {
  ERROR,
  WARN,
  DEBUG,
  INFO,
  LOG
}

const logLevelDescriptions: Record<LogLevel, string> = {
  [LogLevel.ERROR]: 'ERROR',
  [LogLevel.WARN]:  'WARN',
  [LogLevel.DEBUG]: 'DEBUG',
  [LogLevel.INFO]:  'INFO',
  [LogLevel.LOG]:   'LOG',
}

const logLevelColours: Record<LogLevel, string> = {
  [LogLevel.ERROR]: '#fb6464',
  [LogLevel.WARN]:  '#f4b252',
  [LogLevel.DEBUG]: '#9e8b83',
  [LogLevel.INFO]:  '#72fb8e',
  [LogLevel.LOG]:   '#d8d8d8',
}

const timestampColour = '#b9b9b9';
const dateTimeColour = '#b9b9b9';

const defaultLogFunction = (level: string, logLevel: LogLevel, ...messages: any[]): void => {
  if (!process.env.REACT_APP_DEBUG) {
    return;
  }

  console.log(
    `[${level}] %c[${moment()
      .valueOf()}] %c[${moment()
      .format(dateFormats.readableDateTimeSeconds)}] %c[${logLevelDescriptions[logLevel]}]`,
    `color: ${timestampColour};`,
    `color: ${dateTimeColour};`,
    `color: ${logLevelColours[logLevel]};`,
    ...messages,
  );
};

export const logError = (level: string, ...messages: any[]): void =>
  defaultLogFunction(level, LogLevel.ERROR, ...messages);

export const logWarn = (level: string, ...messages: any[]): void =>
  defaultLogFunction(level, LogLevel.WARN, ...messages);

export const logDebug = (level: string, ...messages: any[]): void =>
  defaultLogFunction(level, LogLevel.DEBUG, ...messages);

export const logInfo = (level: string, ...messages: any[]): void =>
  defaultLogFunction(level, LogLevel.INFO, ...messages);

export const log = (level: string, ...messages: any[]): void =>
  defaultLogFunction(level, LogLevel.LOG, ...messages);

